/**
 * Reset the navigation components status
 */
export default ({ store }) => {
	store.commit("navigation/toggleDesktopSubMenu", false);
	store.commit("navigation/toggleMobileMenu", false);
};
